import { Input, Select } from "antd";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormItem from "@/components/FormItem";
import { NAMESPACES } from "@/constants/i18next.constants";
import { filterOption } from "@/utils/filterOption";

import { TBillingOnboardingForm, TValue } from "../../MultiStepForm.types";
import { TARIFF_SECTOR_DROPDOWN } from "./FirstStep.constants";

type TFirstStepProps = {
  control: Control<TBillingOnboardingForm>;
  sectors?: TValue[];
};

function FirstStep({ control, sectors }: TFirstStepProps) {
  const { t } = useTranslation([NAMESPACES.BILLING_ONBOARDING]);

  return (
    <>
      <FormItem
        name="name"
        control={control}
        label={t("billingOnboarding.subscriptionNameLabel")}
      >
        <Input
          placeholder={t("billingOnboarding.subscriptionNamePlaceholder")}
        />
      </FormItem>
      <FormItem
        name="sector"
        control={control}
        label={t("billingOnboarding.sectorLabel")}
      >
        <Select
          showSearch
          filterOption={filterOption}
          options={TARIFF_SECTOR_DROPDOWN.map(option => ({
            label: t(option.label),
            value: option.value,
          }))}
          placeholder={t("billingOnboarding.sectorPlaceholder")}
        />
      </FormItem>
      <FormItem
        name="sectorCode"
        control={control}
        label={t("billingOnboarding.sectorCodeLabel")}
      >
        <Select
          showSearch
          filterOption={filterOption}
          options={sectors}
          placeholder={t("billingOnboarding.sectorCodePlaceholder")}
          style={{
            width: "100%",
          }}
        />
      </FormItem>
    </>
  );
}

export default FirstStep;
